import { createApi } from '@reduxjs/toolkit/query/react';

import { INTAKE_CASE_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

const normalizeIntakeMilestonesResponse = (response) =>
    (response ?? []).map((milestone) => ({
        ...milestone,
        timestamp: milestone.timestamp ?? milestone.milestone_date,
    }));

export const intakeCaseApi = createApi({
    baseQuery: getBaseQuery(INTAKE_CASE_API_URL),
    reducerPath: 'intakeCaseApi',
    endpoints: (build) => ({
        getIntakeCasesForTreatment: build.query({
            query: ({ segmentId, memberId, memberFirstName, memberDOB, productServiceOid }) => ({
                url: `admin/intake_cases/by_member_drug/${segmentId}`,
                params: {
                    member_id: memberId,
                    member_first_name: memberFirstName,
                    member_dob: memberDOB,
                    product_service_oid: productServiceOid,
                },
            }),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving intake cases for the treatment.',
            ),
        }),
        getMilestonesByMemberDrug: build.query({
            query: ({
                segmentId,
                memberId,
                memberFirstName,
                memberDOB,
                productServiceOid,
                keyDate,
                endDate,
            }) => ({
                url: `admin/intake_cases/milestones/by_member_drug/${segmentId}`,
                params: {
                    member_id: memberId,
                    member_first_name: memberFirstName,
                    member_dob: memberDOB,
                    product_service_oid: productServiceOid,
                    key_date: keyDate,
                    end_date: endDate,
                },
            }),
            transformResponse: normalizeIntakeMilestonesResponse,
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving intake case milestones.',
            ),
        }),
    }),
});

export const { useGetIntakeCasesForTreatmentQuery, useGetMilestonesByMemberDrugQuery } =
    intakeCaseApi;

export { normalizeIntakeMilestonesResponse };
